export const LISTE_BON_RECEPTION = {
  title: 'Liste des bons de réception',
  breadcrumb: {
    liste: 'Liste des bons de réception',
  },
  actions: {
    add: 'Nouveau bon de réception',
  },
  table: {
    code: 'Bon de réception n°',
    dateDevisCommande: 'Date',
    fournisseur: 'Fournisseur',
    bonReceptionEtat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
  },
  filtre: {
    etat: 'Etat(s)',
    fournisseur: 'Fournisseur(s)',
    code: 'Code',
    dateDevisCommande: 'Date',
  },
  etatFacture: 'Facturé',
};

export const DETAIL_BON_RECEPTION = {
  title: 'Détail bon de réception n° {code}',
  breadcrumb: {
    liste: 'Liste des bons de réception',
    title: 'Détail bon de réception',
  },
  tabs: {
    informationsTab: 'Informations',
    rapprochementsTab: 'Rapprochements',
  },
  anchor: {
    commande: 'Bon de réception',
    comments: 'Commentaires',
    piecesJointes: 'Pièces jointes',
  },
  rapprochements: {
    table: {
      libelle: 'Libellé',
      codeDcf: 'Code commande',
      dateDcf: 'Date commande',
      nomCommercial: 'Lieu de livraison',
      quantite: 'Qté.',
      quantiteResteARapprocher: 'Qté. reste à rapprocher',
      quantiteARapprocher: 'Qté. rapproché',
    },
  },
  facturer: 'Facturer',
};

export const ADD_EDIT_BON_RECEPTION = {
  title: {
    add: 'Ajouter un bon de réception',
    edit: 'Modifier le bon de réception n°',
  },
  breadcrumb: {
    add: 'Ajouter un bon de réception',
    edit: 'Modifier un bon de réception',
    liste: 'Liste des bons de réception',
  },
  notifications: {
    successCreation: 'Bon de réception créé avec succès',
    successChange: 'Bon de réception modifié avec succès',
  },
  tabs: {
    informationsTab: 'Informations',
    rapprochementsTab: 'Rapprochements',
  },
  informations: {
    title: 'Bon de réception',
    labelIntervenant: 'Fournisseur',
    labelObjet: 'Objet du bon de réception',
    labelDate: 'Date du bon de réception',
    labelReference: 'Référence du bon de réception',
  },
  rapprochements: {
    informations: 'Informations',
    rapprochements: 'Rapprochements',
    labelFournisseur: 'Fournisseur',
    message: {
      noLignesCommandeRapprochees: 'Vous n\'avez aucune ligne de commande rapprochée pour le fournisseur {fournisseur}',
      noLignesCommandeARapprocher: 'Vous n\'avez aucune ligne de commande à rapprocher pour le fournisseur {fournisseur}',
      needFournisseur: 'Vous devez ajouter un fournisseur à votre bon de réception pour faire le rapprochement',
    },
    table: {
      libelle: 'Libellé',
      codeDcf: 'Code commande',
      dateDcf: 'Date commande',
      nomCommercial: 'Lieu de livraison',
      quantite: 'Qté.',
      quantiteResteARapprocher: 'Qté. reste à rapprocher',
      quantiteARapprocher: 'Qté. à rapprocher',
    },
    errors: {
      ligneBRAndCAMustBeDifferent: 'La ligne du bon de réception et la ligne de la commande doivent être différentes',
      ligneBRAndCAMustHaveTheSameProduct: 'La ligne du bon de réception et la ligne de la commande doivent avoir le même produit',
      ligneBRAndCAMustHaveTheSameSupplier: 'La ligne du bon de réception et la ligne de la commande doivent avoir le même fournisseur',
      quantiteMustNotBeGreaterThanQuantiteResteARapprocherLigneBR: 'La quantité à rapprocher ne peut pas être supérieure à la quantité reste à rapprocher de la ligne du bon de réception',
      quantiteMustNotBeGreaterThanQuantiteResteARapprocherLigneCA: 'La quantité à rapprocher ne peut pas être supérieure à la quantité reste à rapprocher de la ligne de la commande',
      sumRapprochementLigneMustNOtGeaterQuantityLine: 'La somme des quantités à rapprocher ne peut pas être supérieure à la quantité de la ligne "{libelle}" ({codeDcf})',
    },
  },
};
